// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1Sjid","noInteraction":"EventWrapper_noInteraction__2AapD","pointerPassthrough":"EventWrapper_pointerPassthrough__2NELX"};